import { useTranslation } from "react-i18next";

import { DimensionType } from "../api/dimensionType";
import { namespaces } from "../consts/i18n";
import useGetProjectRecords from "../hooks/useGetRecords.ts";
import SearchBar from "./inputs/SearchBar";
import useSearchRecords from "../hooks/useSearchRecords";
import RecordListItem from "./RecordListItem";

function RecordList({ projectId }) {
  const { records } = useGetProjectRecords({
    projectId,
    dimension: DimensionType.D2,
  });

  const { t } = useTranslation(namespaces.viewer);

  const [recordsSearchText, setRecordsSearchText] = useSearchRecords();

  // get page height
  const screenHeight = window.screen.height;
  const size = Math.round(screenHeight * 0.65);

  if (!records) return null;

  return (
    size && (
      <div className="flex flex-col gap-3" style={{ maxHeight: size }}>
        <h3 className="text-xxxl font-bold text-700 my-3">
          {t("sidebar.tabs.records")}
        </h3>

        <div className="rounded-xl bg-secondary p-4">
          <SearchBar
            onSearch={(searchText) => {
              setRecordsSearchText(searchText);
            }}
            value={recordsSearchText}
          />
        </div>

        <div className="h-[80%] overflow-y-auto">
          {records?.map((record, i) => (
            <div
              key={record.id + i}
              className="border-t-2 rounded-full border-white hover:bg-secondary"
            >
              <RecordListItem key={record.id} record={record} />
            </div>
          ))}
        </div>
      </div>
    )
  );
}

export default RecordList;
